(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('menuDataManager', MenuDataManagerDirective);

  MenuDataManagerDirective.$inject = [
    '$location'
  ];

  function MenuDataManagerDirective($location) {
    return {
      restrict: 'E',
      templateUrl: 'views/data_manager/menu.html',
      link(scope, element) {
        scope.isActive = isActive;

        function isActive(...urls) {
          return urls.some((url) => $location.url().startsWith(url)) && 'active';
        }

        scope.$root.bodyClass = 'data-manager-body';
        element.addClass('navbar navbar-default navbar-static-side');
      }
    };
  }
}());
